import { render, staticRenderFns } from "./TemplatePage2.vue?vue&type=template&id=d1d9571c&"
import script from "./TemplatePage2.vue?vue&type=script&lang=js&"
export * from "./TemplatePage2.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePage2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports